import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Query, Location, LocationInput, Mutation, CoreLibService } from 'core-lib';
import { MenuItem, TreeNode } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GoogleMapsLoaderService } from './google-maps-loader.service';

declare var google;

@Component({
    selector: 'lib-location-edit',
    templateUrl: './location-edit.component.html',
    styleUrls: ['./location-edit.component.scss'],
    standalone: false
})
export class LocationEditComponent implements OnInit {

    locationContext: Location = {} as Location;
    searchedLocations: Location[] = [];
    firstLoad = true;

    externalId = '';

    LOCATION_FIELDS = `id
            title
            postalCode
            street
            city
            geoLat
            geoLng
            externalId
            created
            createdBy
            usages {
                calendarEvents
            }
    `;

    MUTATION_UPDATE_LOCATION = gql`
    mutation updateLocation($locationId : ID!,$location : LocationInput){
        updateLocation(locationId:$locationId, location : $location){
            ${this.LOCATION_FIELDS}
        }
    }`;

    MUTATION_ADD_LOCATION = gql`
    mutation createLocation($data : LocationInput){
        createLocation(data : $data){
            ${this.LOCATION_FIELDS}
        }
    }`;

    constructor(private apollo: Apollo, public dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private ref: ChangeDetectorRef,public googlemapsLoaderService: GoogleMapsLoaderService,private coreLibService: CoreLibService) {
        this.locationContext = dialogConfig.data?.editedLocation;
        if (this.locationContext == null) {
            this.locationContext = {title: ''} as Location;
        }
        else {
            this.externalId = this.locationContext.externalId;
        }
    }


    ngOnInit(): void {
        this.googlemapsLoaderService.init(['places']).then(() => {});
    }


    ngAfterViewChecked(): void {

        if (this.firstLoad) {
            let elem = null;
            if (this.coreLibService.isNativeIOS()) {
                elem = document.getElementById("Location")?.querySelectorAll("p-autoComplete")[0] as HTMLElement;
            } else {
                elem = document.getElementById("Location")?.querySelectorAll("label")[0] as HTMLElement;
            } if (elem != null) {
                elem?.setAttribute("tabindex", "0");
                elem?.focus();

                this.firstLoad = false;
            }
        }
    }

    get selectedLocation() {
        return this.locationContext;
    }

    set selectedLocation(location: Location | string) {
        if (location['title']) {
            const loc = location as Location;
            const tempId = this.locationContext.id;
            this.locationContext = loc;
            this.locationContext.id = tempId;
        } else {
            this.locationContext.title = location as string;
        }
    }

    onCancelEdit(){
        this.dialogRef.close(null);
    }

    onAddOrUpdateLocation(location: Location): void {
        if (this.locationContext.id) {
            this.onLocationChanged(location);
        } else {
            this.onAddLocation(location);
        }
    }

    /**
     * on change location
     * @param location
     */
    onLocationChanged(location: Location): void {
        const locationInput = { title: location.title, externalId: location.externalId, geoLat: location.geoLat, geoLng: location.geoLng, street: location.street, city: location.city, postalCode: location.postalCode } as LocationInput;
        this.apollo.mutate<Mutation>({
            mutation: this.MUTATION_UPDATE_LOCATION,
            variables: {
                location: locationInput, locationId: location.id
            }
        }).subscribe((result) => {
            if (!result.errors) {
                this.dialogRef.close(result.data.updateLocation);
            }
        });
    }

    /**
     * add location
     * @param event
     */
    onAddLocation(event: Location): void {
        const locationInput = { title: event.title, externalId: event.externalId, geoLat: event.geoLat, geoLng: event.geoLng, street: event.street, city: event.city, postalCode: event.postalCode } as LocationInput;
        this.apollo.mutate<Mutation>({
            mutation: this.MUTATION_ADD_LOCATION,
            variables: {
                data: locationInput
            }
        }).subscribe((result) => {
            if (!result.errors) {
                this.dialogRef.close(result.data.createLocation);
            }
        });
    }

    onSearchPlaceSelected(event: Location): void {
        const service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails(
            {
                placeId: event['placeId'],
                fields: ['address_components']
            }, (result) => {
                if (result && result.address_components && result.address_components) {
                    const addressComponent = result.address_components;
                    let tempStreeNumber = "";
                    for (const component of addressComponent) {
                        if (component.types.includes('postal_code')) {
                            event.postalCode = component.long_name;
                        } else if (component.types.includes('route')) {
                            event.street = component.long_name;
                        } else if (component.types.includes('locality')) {
                            event.city = component.long_name;
                        }
                        else if (component.types.includes('street_number')) {
                            tempStreeNumber = component.long_name;
                        }
                    }
                    if (event.street) {
                        event.street = `${event.street} ${tempStreeNumber}`;
                    }
                }
                this.ref.detectChanges();
            }
        );
    }

    searchPlaces(event): void {
        const query = event.query;
        const request = {
            query: query
        };

        const service = new google.maps.places.PlacesService(document.createElement('div'));
        service.textSearch(request, (results) => {
            const temp = results.map((place) => {
                const ptemp = { title: place.name, geoLat: place.geometry.location.lat(), geoLng: place.geometry.location.lng(), externalId: this.externalId } as Location;
                ptemp['placeId'] = place.place_id;
                ptemp['address'] = place.formatted_address;
                return ptemp;
            });
            this.searchedLocations = [...temp];
            this.ref.detectChanges();
        });
    }
}
